import React, { forwardRef, useImperativeHandle, useRef, } from 'react';
import classnames from 'classnames';
import { useComponentDidUpdate } from '../../../modules/core';
import { OverlayWithAutoHide, } from '../../../modules/core/components';
export const CallOverlayItem = forwardRef(({ className, disabled, children }, ref) => {
    const overlayRef = useRef();
    const itemClassName = classnames('call-overlay-item', className);
    useImperativeHandle(ref, () => ({
        show: () => overlayRef.current.show(),
        hide: () => overlayRef.current.hide(),
    }));
    useComponentDidUpdate(() => overlayRef.current.show(), [disabled]);
    return (<OverlayWithAutoHide className={itemClassName} animate opacity={66} ref={overlayRef} zIndex={9} hideAfter={1000}>
      {disabled ? children : children}
    </OverlayWithAutoHide>);
});
